import { Chance } from "chance"
import { DictionaryPatient } from "etl/types";

const chance = new Chance();

export const dictionaryPatientFactoryMock = (howMany: number): DictionaryPatient[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/dictionary_patients/${index + 1}`,
		id: index + 1,
		numero: chance.word(),
		last_name: chance.name().split(' ')[0],
		first_name: chance.name().split(' ')[1],
		birth_date: chance.word(),
		email: chance.email(),
		phone: chance.phone(),
		phone_mobile: chance.phone(),
		aw_id: chance.word(),
		doublon_aw_ids: chance.word(),
		doublon_ids: chance.word(),
		new_import_id: chance.word(),
	}));
